import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/paises';

/**
 * GET Tipos de Seguridad Social
 * @returns {Promise<object[]>}
 */
export const getPaises = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Pais
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPais = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Pais
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPais = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Pais
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPais = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Pais
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePais = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
